<input
  id="{{ id }}"
  type="checkbox"
  class="uk-checkbox select-item"
  (change)="switchSelection()"
  [checked]="(state | async)[field].includes(id)" />
